export type SummeryItem = {
  [name: string]: {
    max: number
    avg: number
    sum: number | null
    maxTime: string
    last?: { [index: number]: number }
  }
}

export type ThresholdItem = {
  [key: string]: {
    startTime: string
    endTime: string
  }
}

export type SummaryItemKey = 'max' | 'avg' | 'sum' | 'maxTime' | 'last'

export default class Summery {
  public stationId: string
  public items: SummeryItem
  public thresholdItems?: ThresholdItem

  constructor({
    stationId,
    items,
    thresholdItems,
  }: {
    stationId: string
    items: SummeryItem
    thresholdItems?: ThresholdItem
  }) {
    this.stationId = stationId
    this.items = items
    this.thresholdItems = thresholdItems
  }
}
